import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import LockIcon from "@mui/icons-material/Lock";
import { TextField, Button, Typography, Box, Grid, Paper, Alert } from "@mui/material";

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Menangani pengiriman form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (username === "" || password === "") {
      setError("Username dan password harus diisi.");
      return;
    }

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${process.env.REACT_APP_API_KEY}`,
        },
        body: JSON.stringify({ user: username, pass: password }),
      });

      const result = await response.json();
      if (response.ok && result.status === "success") {
        localStorage.setItem("token", result.data.token);

        navigate("/admin/dashboard");
      } else {
        setError(result.message || "Login gagal. Coba lagi.");
      }
    } catch (err) {
      setError("Terjadi kesalahan server. Coba lagi nanti.");
    }
  };

  return (
    <Grid container justifyContent="center" alignItems="center" sx={{ height: "100vh" }}>
      <Paper elevation={6} sx={{ padding: 4, maxWidth: 400, width: "100%" }}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h4" component="h1" gutterBottom>
            Login
          </Typography>
        </Box>
        <form onSubmit={handleSubmit}>
          <Box mb={2}>
            <TextField
              fullWidth
              label="Username"
              variant="outlined"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              InputProps={{
                startAdornment: <PersonIcon sx={{ mr: 1 }} />,
              }}
              placeholder="Masukkan username"
            />
          </Box>
          <Box mb={2}>
            <TextField
              fullWidth
              label="Password"
              type="password"
              variant="outlined"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                startAdornment: <LockIcon sx={{ mr: 1 }} />,
              }}
              placeholder="Masukkan password"
            />
          </Box>
          {error && (
            <Box mb={2}>
              <Alert severity="error">{error}</Alert>
            </Box>
          )}
          <Button type="submit" fullWidth variant="contained" color="primary" size="large">
            Login
          </Button>
        </form>
      </Paper>
    </Grid>
  );
}

export default Login;
